import React, { useEffect, useState } from "react";
import icons from "../../../assets/images/constantIcons";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddExpense from "./useAddExpense";
import AddExpenseForm from "./AddExpenseForm";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CategoryManage from "./CategoryManage";

const AddExpense = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    filters,
    updateFilter,
    fetchExpenses,
    cashIn,
    cashOut,
    netBalance,
    clearFilters,
    loading
  } = useAddExpense();

  const [selectedType, setSelectedType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [category, setCategory] = useState([]);
  const [parties, setParties] = useState([]);
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(null);

  const openModalWithType = (type) => {
    setSelectedType(type);
    setIsModalOpen(true);
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const fetchParties = async () => {
    try {
      const response = await apiService.get("/parties");
      setParties(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };
  const fetchCategories = async () => {
    try {
      const response = await apiService.get("/expense_categories");
      setCategory(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    fetchParties();
    fetchCategories()
  }, [])

  return (
    <div className="flex flex-col">
      <div className="flex flex-wrap items-center justify-between gap-4 my-4 w-full">
        <h1 className="main_heading text-2xl xl:text-[30px]">Expense</h1>

        <div className="flex flex-wrap gap-2">
          <p className="border rounded px-3 py-2 text-sm bg-white text-G500 hover:text-blue hover:border-blue" onClick={() => {
            clearFilters();
            fetchExpenses();
          }}>Clear Filter</p>
          <div className="flex flex-wrap gap-2">
            <select
              className="border rounded px-3 py-2 text-sm bg-white text-G500 outline-none"
              value={filters.filter}
              onChange={(e) => {
                const value = e.target.value;
                updateFilter("filter", value);

                if (value === "custom") {
                  setIsCustomDateOpen(true);
                } else {
                  // clear custom dates if not custom
                  updateFilter("from", "");
                  updateFilter("to", "");
                  fetchExpenses();
                }
              }}
            >
              <option value="">Duration: All Time</option>
              <option value="yesterday">Yesterday</option>
              <option value="today">Today</option>
              <option value="custom">Custom</option>
              <option value="">Clear Filter</option>
            </select>

            {/* Custom Date Picker Modal */}
            {isCustomDateOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] relative">
                  <h1 className="text-G800 text-lg mb-3">Select Custom Date</h1>
                  <DatePicker
                    selected={filters.from}
                    onChange={(date) =>
                      updateFilter("from", date)
                    }
                    selectsStart
                    placeholderText="From Date"
                    className="text-G500 placeholder:text-xs border px-3 py-2 rounded w-full mb-3 text-sm outline-none"
                    dateFormat="yyyy-MM-dd"
                  />
                  <DatePicker
                    selected={filters.to}
                    onChange={(date) =>
                      updateFilter("to", date)
                    }
                    selectsEnd
                    placeholderText="To Date"
                    className="text-G500 placeholder:text-xs border px-3 py-2 rounded w-full text-sm outline-none"
                    dateFormat="yyyy-MM-dd"
                  />

                  <div className="flex justify-start space-x-4 mt-6">
                    <button
                      onClick={() => {
                        fetchExpenses();
                        setIsCustomDateOpen(false);
                      }}
                      className="border border-green text-green hover:bg-green hover:text-white py-1 rounded-md w-[75px] text-sm text-center"
                    >
                      Apply
                    </button>
                    <button
                      onClick={() => {
                        updateFilter("filter", "");
                        updateFilter("from", "");
                        updateFilter("to", "");
                        setIsCustomDateOpen(false);
                      }}
                      className="border border-green hover:bg-green hover:text-white text-green py-1 rounded-md w-[75px] text-sm text-center"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* entry type */}
          <select
            className="border rounded px-3 py-2 text-sm bg-white text-G500 outline-none"
            value={filters.entry_type}
            onChange={(e) => updateFilter("entry_type", e.target.value)}
          >
            <option value="">Types: All</option>
            <option value="cash_in">Cash In</option>
            <option value="cash_out">Cash Out</option>
            {/* <option value="">Clear Filter</option> */}
          </select>
          {/* paymen tmode */}
          {/* <select
            className="border rounded px-3 py-2 text-sm bg-white text-G500 outline-none"
            value={filters.payment_mode}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                updateFilter("payment_mode", []);
              } else {
                updateFilter("payment_mode", [value]);
              }
            }}
          >
            <option value="">Payment Modes: All</option>
            <option value="cash">Cash</option>
            <option value="card">Card</option>
            <option value="upi">Upi</option>
          </select> */}

          {/* categories */}
          {/* <select
            className="border rounded px-3 py-2 text-sm bg-white text-G500 outline-none"
            value={filters.category_id}
            onChange={(e) => updateFilter("category_id", e.target.value)}

          >
            <option value="">Categories: All</option>
            {category.length === 0 ? (
              <option disabled>No categories</option>
            ) : (
              category.map((value, index) => (
                <option value={value.id} key={index}>
                  {value.name}
                </option>
              ))
            )}
          </select> */}


          {/* parties */}
          <select
            className="border rounded px-3 py-2 text-sm bg-white text-G500 outline-none"
            value={filters.party_id}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                updateFilter("party_id", []);
              } else {
                updateFilter("party_id", [value]);
              }
            }}
          >
            <option value="">Parties: All</option>
            {parties.length === 0 ? (
              <option disabled>No parties</option>
            ) : (
              parties.map((value, index) => (
                <option value={value.id} key={index}>
                  {value.name}
                </option>
              ))
            )}
          </select>

        </div>
      </div>

      <div className="flex flex-wrap justify-between items-center mb-4 gap-4 w-full">
        <div className="flex gap-4">
          <button
            onClick={() => openModalWithType("cash_in")}
            className="bg-green800 flex justify-center items-center gap-2 w-32 h-10 text-white font-medium text-sm px-4 py-2 rounded-md"
          >
            <icons.FaPlus /> Cash In
          </button>

          <button
            onClick={() => openModalWithType("cash_out")}
            className="bg-darkred flex justify-center items-center gap-2 w-32 text-white font-medium text-sm px-4 py-2 rounded-md"
          >
            <icons.FaMinus /> Cash Out
          </button>
        </div>

        <div className="flex items-center gap-4 my-4 relative">
          <button onClick={() => setIsCategoryOpen(true)} className="bg-buttoncolor text-white text-sm px-2 py-2 rounded-md">Create Party</button>
          {isCategoryOpen && (
            <CategoryManage
              isOpen={() => setIsCategoryOpen(true)}
              onClose={() => setIsCategoryOpen(false)}
            />
          )}

          <div className="flex border items-center text-G100 p-2 rounded-lg font-normal bg-white">
            <icons.GoSearch className="mr-2" />
            <input
              name="search"
              type="text"
              placeholder="Search by remark or amount"
              className="w-[150px] md:w-[250px] appearance-none outline-none placeholder:text-sm"
              value={filters.search}
              onChange={(e) => updateFilter("search", e.target.value)}
            />
          </div>
        </div>
      </div>

      <AddExpenseForm isOpen={isModalOpen} onClose={toggleModal} entryType={selectedType} fetchExpenses={fetchExpenses} />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mb-6 w-full">
        <div className="border p-4 flex items-center gap-4 ">
          <div className="w-10 h-10 rounded-full bg-green100 flex items-center justify-center">
            <icons.FaPlus className="text-green700 text-lg" />
          </div>
          <div>
            <div className="text-sm text-gray-600 font-medium">Cash In</div>
            <div className="text-2xl font-bold text-black">{`₹ ${Math.trunc(cashIn)}`}</div>
          </div>
        </div>
        <div className="border p-4 flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-[#EB949E] flex items-center justify-center">
            <icons.FaMinus className="text-darkred text-lg" />
          </div>
          <div>
            <div className="text-sm text-gray-600 font-medium">Cash Out</div>
            <div className="text-2xl font-bold text-black">{`₹ ${Math.trunc(cashOut)}`}</div>
          </div>
        </div>

        <div className="border p-4 flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-[#B5E2FF] flex items-center justify-center">
            <icons.IoReorderTwoSharp className="text-checkoutblue text-lg" />
          </div>
          <div>
            <div className="text-sm text-gray-600 font-medium">Net Balance</div>
            <div className="text-2xl font-bold text-black">{`₹ ${Math.trunc(netBalance)}`}</div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center my-4">
          <p className="text-green700 font-medium">Loading data...</p>
        </div>
      ) : (
        <div className="my-2 mb-6 overflow-auto horizontalscroll">
          <Table columns={columns} data={currentRows} />
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AddExpense;
